import type { TaskCustomField } from '@/task-manager/entities/task-custom-field';

import type { GetCardDetailViewOutputCardCustomField } from '../fetch-client';

export function customFieldMapper(
  data: GetCardDetailViewOutputCardCustomField,
): TaskCustomField {
  return {
    name: data.name,
    value: data.value,
  };
}
